<div class="container-center">
  <div class="logo-center">
    <img src="assets/img/rsm_logo.svg" alt="rsm-logo" width="320px">
    <div class="d-flex justify-content-center mt-5">
      <div class="spinner-border text-light" style="width: 3rem; height: 3rem" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</div>
